'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var bitswap = require('./bitswap.js');

var createBitswap = function createBitswap(libp2p, blockstore) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new bitswap.Bitswap(libp2p, blockstore, options);
};

exports.createBitswap = createBitswap;